import {
  Avatar,
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Icon,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import _, { capitalize, isUndefined } from 'lodash';
import { useEffect, useReducer, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
  ACTION_OPEN_RIGHT_FLOATING_DRAWER,
} from '../../../../component/MainUIFrame/constants';
import {
  useMainFrameDispatch,
  useMainFrameState,
} from '../../../../component/MainUIFrame/MainFrame';
import {
  humanGenderOptionsList,
  humanNamePrefixOptionsOptionsList,
  humanNameSuffixOptionsList,
} from '../../../../data/fhirHumanNameData';
import { CheckboxComponent } from '../../../../component/FhirComponents/uiComponent/fhirComponentUi';
import NPIRegistryDrawer from '../../../../component/NPI/NPIRegistryDrawer';
import FHIROrganizationQuickAdd from '../../../../component/FhirComponents/molecule/fhirOrganizationQuickAdd';
import FHIRPractitionerQuickAdd from '../../../../component/FhirComponents/molecule/fhirPractitionerQuickAdd';
import { useSelector } from 'react-redux';

const ManualProviderView = props => {
  const { title, data, providerType, isNPISearch, managingOrg = false } = props;

  const [npiData, setNpiData] = useState(data);

  console.log(`NPI DATA`, npiData);

  return (
    <Grid container>
      <Grid item sm={12}>
        <Typography
          style={{
            display: props?.fhirPatientHide ? 'none' : 'block',
          }}
        >
          {title}
        </Typography>
      </Grid>
      {providerType === 'NPI-2' ? (
        <FHIROrganizationQuickAdd
          refresh={props?.refresh}
          setRefresh={props?.setRefresh}
          npiObject={npiData}
          isInsurance={props?.isInsurance}
          managingOrg={managingOrg}
          handleQuickAddClose={props?.handleQuickAddClose}
          of="quickAdd"
        />
      ) : (
        <FHIRPractitionerQuickAdd
          refresh={props?.refresh}
          setRefresh={props?.setRefresh}
          npiObject={npiData}
          practitionerData={props?.practitionerData}
          setNPI={props?.setNPI}
          handleQuickAddClose={props?.handleQuickAddClose}
          of="quickAdd"
        />
      )}
    </Grid>
  );
};

function localReducer(state, action) {
  switch (action.type) {
    case '1':
      return { provType: 'NPI-1' };
    case '2':
      return { provType: 'NPI-2' };
    default:
      return {
        provType: 'NPI-1',
      };
  }
}

const AddProviderRightDrawerComponent = props => {
  const { isRightDrawerOpen } = useMainFrameState();
  const dispatch = useMainFrameDispatch();

  const selectedVersion = useSelector(
    state => state.changeVersion.selectedVersion
  );

  const [title, setTitle] = useState();
  const [data, setData] = useState({});
  const [isNPISearch, setIsNPISearch] = useState(true);
  const [providerType, setProviderType] = useState(
    props?.type === 'billing'
      ? props?.searchType === 'organization'
        ? 'NPI-2'
        : 'NPI-1'
      : 'NPI-1'
  );
  const [npiData, setNpiData] = useState(null);
  const [state, localDispatch] = useReducer(localReducer, { provType: '0' });
  const [orgState, setOrgState] = useState(false);

  const [isNPISearchDisabled, setIsNPISearchDisabled] = useState(false);

  useEffect(() => {
    let tTitle = props?.coverageOrganization
      ? `Add Insurance Organization`
      : `Add ${capitalize(props?.type)} Provider`;

    setTitle(tTitle);
    if (props?.type === 'billing') {
      console.warn('condition true');
      setOrgState(false);
    } else {
      console.log('else conditon true');
      if (props?.coverageOrganization) {
        setProviderType('NPI-2');
        setOrgState(false);
      } else {
        setOrgState(true);
      }
    }
  }, [props?.type, props?.coverageOrganization]);

  useEffect(() => {
    if (selectedVersion === 'IN') {
      setIsNPISearch(false);
      setIsNPISearchDisabled(true);
    }
  }, [selectedVersion]);

  useEffect(() => {
    if (props?.isDisable && props?.searchType === 'organization') {
      setIsNPISearch(false);
      setIsNPISearchDisabled(true);
    }
  }, [props]);

  const searchInNpiCheckboxValidation = {
    title: 'Search in NPI Registry',
    value: isNPISearch,
    disabled: isNPISearchDisabled,
  };

  useEffect(() => {
    if (state.provType === '0') {
      if (providerType === 'NPI-1') {
        localDispatch({ type: '1' });
      } else {
        localDispatch({ type: '2' });
      }
    } else if (state.provType !== providerType) {
      if (providerType === 'NPI-1') {
        localDispatch({ type: '1' });
      } else {
        localDispatch({ type: '2' });
      }
    }

    if (
      /*(!isNPISearch) &&*/ state.provType !== '0' &&
      state.provType !== providerType &&
      npiData !== null
    ) {
      if (providerType === 'NPI-1') {
        localDispatch({ type: '1' });
        setNpiData(null);
      } else {
        localDispatch({ type: '2' });
        setNpiData(null);
      }
    }
  });

  useEffect(() => {
    if (props?.coverageOrganization) {
      setIsNPISearch(false);
      setIsNPISearchDisabled(true);
    }
  }, [props?.coverageOrganization]);

  useEffect(() => {
    if (props?.fromUser) {
      setIsNPISearchDisabled(true);
    }
  }, [props?.fromUser]);

  useEffect(() => {
    console.log(
      `ED PT RES`,
      npiData?.enumeration_type,
      providerType,
      npiData?.enumeration_type === providerType && npiData
    );
  }, [npiData?.enumeration_type, providerType]);

  return (
    <>
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
        container
      >
        {
          <Box
            sx={{
              display: 'flex',
              justifyContent: isRightDrawerOpen ? 'flex-start' : 'center',
              alignItems: 'center',
            }}
          >
            {isRightDrawerOpen ? (
              <IconButton
                onClick={() => {
                  if (props?.handleQuickAddClose) {
                    props?.handleQuickAddClose();
                  } else {
                    dispatch({
                      type: ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
                    });
                  }
                }}
              >
                <Icon>chevron_right</Icon>
              </IconButton>
            ) : (
              <IconButton
                onClick={() => {
                  dispatch({
                    type: ACTION_OPEN_RIGHT_FLOATING_DRAWER,
                  });
                }}
              >
                <Icon>chevron_left</Icon>
              </IconButton>
            )}
          </Box>
        }
        {isRightDrawerOpen && (
          <Grid container spacing={1} px={1}>
            {!isNPISearchDisabled && (
              <>
                <Grid item sm={12}>
                  <CheckboxComponent
                    {...searchInNpiCheckboxValidation}
                    onChange={event => {
                      setIsNPISearch(event?.target?.value);
                    }}
                  />
                </Grid>
                {/* <Grid
                  item
                  sm={12}
                  style={{ display: props?.fhirPatientHide ? 'none' : 'block' }}
                >
                  <RadioGroup
                    row
                    name="providerType"
                    value={providerType}
                    onChange={event => {
                      setProviderType(event?.target?.value);
                    }}
                  >
                    <FormControlLabel
                      value="NPI-1"
                      control={<Radio />}
                      label="Individual"
                      disabled={props?.isDisable}
                    />
                    <FormControlLabel
                      disabled={orgState}
                      value="NPI-2"
                      control={<Radio />}
                      label="Organization"
                    />
                  </RadioGroup>
                </Grid> */}
              </>
            )}
            <Grid item sm={12}>
              {isNPISearch ? (
                <NPIRegistryDrawer
                  setNPI={npi => {
                    setNpiData(npi?.data);
                    setIsNPISearch(false);
                  }}
                  setNPIUserForm={props?.setNPI}
                  disableCloseButton
                  npiType={providerType}
                  setPractitionerSelectedFromLocal={
                    props?.setPractitionerSelectedFromLocal
                  }
                  fromUser={props?.fromUser}
                  handleQuickAddClose={props?.handleQuickAddClose}
                  header="Search NPI Registry"
                />
              ) : (
                <ManualProviderView
                  key={npiData?.number}
                  isNPISearch={isNPISearch}
                  refresh={props?.refresh}
                  setRefresh={props?.setRefresh}
                  providerType={providerType}
                  data={providerType === npiData?.enumeration_type && npiData}
                  title={props?.fhirPatientHide ? '' : title}
                  practitionerData={props?.practitionerData}
                  setNPI={props?.setNPI}
                  isInsurance={props?.coverageOrganization}
                  managingOrg={
                    props?.isDisable && props?.searchType === 'organization'
                  }
                  handleQuickAddClose={props?.handleQuickAddClose}
                />
              )}
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default AddProviderRightDrawerComponent;
